import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { isOpen: boolean } = {
	isOpen: false
};

const explicacionHabilidadesModalStateSlice = createSlice({
	name: 'explicacionHabilidadesModalState',
	initialState,
	reducers: {
		setExplicacionHabilidadesModalState: (state, action: PayloadAction<{ isOpen: boolean }>) => {
			return action.payload;
		}
	}
});

export const { setExplicacionHabilidadesModalState } = explicacionHabilidadesModalStateSlice.actions;

export default explicacionHabilidadesModalStateSlice.reducer;
